export default {
  推荐好友加入: `Giới thiệu bạn bè `,
  赢取巴塞罗那VIP之旅:'Thắng Ngay Chuyến Du lịch <span class="vipWord">VIP</span> đến Barcelona',

  成为EBC推荐官: "Không có thời điểm nào tốt hơn hiện tại để giới thiệu bạn bè tham gia EBC Financial Group, giúp họ trải nghiệm phương thức giao dịch ưu việt hơn.",
  立即参与: "GIỚI THIỆU NGAY",
  专属奖励等你拿: "Phần Thưởng Độc Quyền Dành Riêng Cho Bạn",
  您将获得以下奖励:'Hãy mời 66 người bạn của bạn tham gia trước ngày 23/5/2025 để nhận các phần thưởng sau:',
  西班牙巴塞罗那之旅:'Một chuyến du lịch đến Barcelona, Tây Ban Nha được tài trợ toàn bộ chi phí',
  巴塞罗那足球俱乐部主场比赛VIP门票:'Vé VIP chiêm ngưỡng ngay trận đấu sân nhà của CLB FC Barcelona',
  巴塞罗那足球俱乐部专属晚宴:'Tham dự buổi tiệc tối đặc biệt cùng FC Barcelona',
  往返机票酒店住宿当地接送导服务:'Bao gồm vé máy bay khứ hồi, khách sạn và các tour tham quan địa phương',
  如何赢取大奖:'Cách thức tham gia?',
  登录EBC用户中心: "Đăng nhập Trung tâm người dùng EBC",
  "进入“大赛推荐官”活动页面": 'Vào trang hoạt động “Đại sứ giới thiệu cuộc thi”',
  生成您的邀请链接或二维码: "Tạo liên kết mời hoặc mã QR cá nhân của bạn",
  成功推荐66人: "Đạt được 66 lời giới thiệu thành công",
  成功推荐奖励:'Chỉ cần bạn bè mà bạn giới thiệu nạp ít nhất 500 USD và thực hiện ít nhất 1 giao dịch với EBC trong thời gian diễn ra chiến dịch - Bạn đã tiến gần hơn bao giờ hết đến giải thưởng danh giá này!',
  你还在等什么:'Bạn còn chần chừ gì nữa?',
  EBC为交易者捉供更低点差:'Giới thiệu ngay hôm nay! EBC chào đón các nhà giao dịch tham gia nền tảng ưu việt của chúng tôi — với mức chênh lệch thấp, chính sách hoàn tiền cạnh tranh và vô vàn ưu đãi hấp dẫn khác. Và chúng tôi rất mong được chào đón bạn tại Barcelona!',
  每一次推荐: "Mỗi lần giới thiệu là một pha kiến tạo vàng để mở ra cánh cửa đến Barca.",
  参与规则: "Quy tắc tham gia:",
  成为EBC推荐官并邀请66人: "Trở thành Đại sứ giới thiệu của EBC và mời đủ 66 người;",
  所有被邀请人均入金大于等于$500: `Mỗi người được mời phải nạp tối thiểu 500 đô la Mỹ và hoàn tất giao dịch.`,
  参与方法: "Cách tham gia:",
  立即推荐: "Giới thiệu ngay để nhận sự hỗ trợ từ bạn bè, tri ân huyền thoại.",
  
  巴萨荣耀之旅: "Hành trình vinh quang đến Barcelona",
  每笔订单都是攻守博弈的艺术: `Mỗi giao dịch là sự cân bằng tinh tế giữa tấn công và phòng thủ. Mỗi quyết định bạn đưa ra có thể trở thành bàn thắng quyết định trên thị trường. Vinh quang đang chờ đón những người chiến thắng.`,
  活动时间: "Thời gian chương trình:",
  "2025年2月22日": "Từ 01:00:00 ngày 22/02/2025 đến 23:59:59 ngày 23/05/2025 (giờ MT4/MT5).",
  活动规则: "Quy định chương trình",
  ruleList: [
    "Hoạt động này không xung đột với phần thưởng giới thiệu thông thường và các chương trình khác.",
    "Người được giới thiệu phải hoàn tất nạp tiền và thực hiện giao dịch, các khoản chuyển khoản từ bên thứ ba không hợp lệ.",
    "Tiền thưởng giới thiệu chỉ áp dụng cho những nhà giao dịch tuân thủ quy định. EBC có toàn quyền thu hồi tiền thưởng nếu vi phạm.",
    "tài khoản đăng ký thông qua giới thiệu không được phép chuyển nhượng đại lý.",
    "Phần thưởng sẽ được trao khi tài khoản được kích hoạt hợp lệ; ghế xem VIP bao gồm vé máy bay và chỗ ở.",
    "EBC sở hữu quyền giải thích cuối cùng đối với sự kiện này.",
  ],
};
